import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type LocalizerService from '@/Shared/Service/Localization/LocalizerService'
import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'
import {
    RecurrenceFrequencyTypeEnum,
    type RecurrenceSettingsData,
} from '@/Shared/AutoGenerated/Main'

export default class RecurrenceSettings {
    constructor(
        public readonly frequencyType: RecurrenceFrequencyTypeEnum,
        public readonly maximumNumberOfRecurringMeetings: number,
        public readonly skipDatesWithNoAvailability: boolean,
        public readonly allowCustomNumberOfRecurringMeetings: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    isRecurring(): boolean {
        return this.frequencyType !== RecurrenceFrequencyTypeEnum.Single
    }

    getQuantityDescription(localizerService: LocalizerService): string {
        const upToText = localizerService.translate(
            TextTokenEnum.BookingForm_UpTo,
        )
        const recurringMeetingsText = localizerService.translate(
            TextTokenEnum.BookingForm_RecurringMeetings,
        )

        return (
            (this.allowCustomNumberOfRecurringMeetings ? `${upToText} ` : '') +
            this.maximumNumberOfRecurringMeetings +
            ` ${recurringMeetingsText}`
        )
    }

    getQuantityOptions(): number[] {
        const options = []

        for (
            let index = 2;
            index <= this.maximumNumberOfRecurringMeetings;
            index++
        ) {
            options.push(index)
        }

        return options
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: RecurrenceSettingsData,
    ): RecurrenceSettings {
        return new RecurrenceSettings(
            entityData.frequencyType,
            entityData.maximumNumberOfRecurringMeetings,
            entityData.skipDatesWithNoAvailability,
            entityData.allowCustomNumberOfRecurringMeetings,
        )
    }
}
